import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, a = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M4.894 7.748c0-.828-.522-1.53-1.26-1.81v-4.24a.68.68 0 0 0-.676-.676.68.68 0 0 0-.675.676v4.24c-.738.28-1.26.982-1.26 1.81 0 .828.522 1.53 1.26 1.81v4.744c0 .37.306.675.675.675a.68.68 0 0 0 .675-.675V9.558a1.935 1.935 0 0 0 1.26-1.81Zm-1.936.585a.584.584 0 1 1 0-1.17.584.584 0 1 1 0 1.17Zm6.978 2.791c0-.828-.523-1.53-1.26-1.81V1.698A.68.68 0 0 0 8 1.022a.68.68 0 0 0-.675.676v7.616c-.739.28-1.26.982-1.26 1.81 0 .828.521 1.53 1.26 1.81v1.368c0 .37.306.675.675.675a.68.68 0 0 0 .675-.675v-1.368a1.935 1.935 0 0 0 1.26-1.81ZM8 11.71a.584.584 0 1 1 0-1.17.584.584 0 1 1 0 1.17Zm5.717-8.068c.738.28 1.26.982 1.26 1.81 0 .828-.522 1.53-1.26 1.81v7.04a.68.68 0 0 1-.675.675.68.68 0 0 1-.675-.675v-7.04a1.935 1.935 0 0 1-1.26-1.81c0-.828.521-1.53 1.26-1.81V1.698a.68.68 0 0 1 .675-.676.68.68 0 0 1 .675.676v1.944Zm-1.26 1.81a.584.584 0 1 0 1.17 0 .584.584 0 1 0-1.17 0Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  a
];
function r(v, l) {
  return e(), t("svg", o, [...n]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
